<template>
    <div id="app">
        <!-- <div v-if="go_new" class="go-new">
            <p>地址更新，<span>{{num}}</span>秒后跳转到新地址...</p>
        </div> -->
        <router-view></router-view>
        <serviceFee :isShow="serviceFee_isShow" :data="total_money"></serviceFee>
    </div>
</template>

<script>
import axios from 'axios'; // AJAX封装类
import { config } from './utils/config'; //配置
import bus from './components/common/bus.js';
import serviceFee from './components/common/serviceFee.vue';
var _this;
export default {
    components: {
        serviceFee
    },
    data() {
        return {
            num: 3,
            serviceFee_isShow: false,
            titleStr: '',

            total_money: ''
        };
    },

    created() {
        _this = this;
        
        // login.vue 判断是否为小琳代驾，往缓存里放完数据,bus.$emit('upDataCityInfo', localStorage.getItem('cityInfo'));在执行下面 bus.$on代码
        // bus.$on('upDataCityInfo', (msg) => {

        //     console.log(msg,'触发了11');

        //     console.log('app.vue');
        //     // 小琳代驾主题设置vue根据条件全局引入css
        //     _this.titleStr = JSON.parse(msg).city_tag; // 注意数据类型JSON.parse
        //     console.log(_this.titleStr,'_this.titleStr');

        //     if (_this.titleStr == 'HAIKOU') {
        //         require(`@/assets/css/theme-green/xiaolin.css`);
        //         console.log('小琳======');
        //     } else {
        //         require(`@/assets/css/theme-green/index1.css`);
        //         // require(`@/assets/css/theme-green/xiaolin.css`);

        //     }
        // });
        // console.log('app.vue');
        // // 小琳代驾主题设置vue根据条件全局引入css 直接写导致先执行这个代码，又在login判断是否为小琳代驾，代码顺序出问题导致无法正确引入小琳样式
        // _this.titleStr = JSON.parse(localStorage.getItem('cityInfo')).city_tag;

        // if (_this.titleStr == 'HAIKOU') {
        //     require(`@/assets/css/theme-green/xiaolin.css`);
        //     console.log('小琳======');
        // } else {
        //     require(`@/assets/css/theme-green/index1.css`);
        // }

        // const themeName = this.$themeName;
        // console.log(themeName,'themeName=');
        // if (themeName) {
        //     try {
        //         require(`@/assets/css/theme-green/${themeName}.css`); // 假设CSS文件放在assets/css/theme-green目录下
        //         console.log(`Theme ${themeName} has been applied.`,'===========');
        //     } catch (e) {
        //         console.error(`Theme ${themeName} could not be applied.`, e);
        //     }
        // }

        axios.defaults.baseURL = config.axios_normalURL;
        // 高德语音播报token
        _this
            .$post('/system/getBaiduOpenToken')
            .then((res) => {
                localStorage.setItem('bdToken', res.data.access_token);
            })
            .catch((err) => {});
        axios.defaults.baseURL = config.axios_baseURL; //请求base url

        axios.defaults.baseURL = config.axios_normalURL; //请求normal url
        _this
            .$post('/system/systemTimestamp')
            .then((res) => {
                let time_difference = res.data.timestamp - Math.round(new Date() / 1000);

                sessionStorage.setItem('time_difference', time_difference);
            })
            .catch((err) => {});

        axios.defaults.baseURL = config.axios_baseURL; //请求base url

        bus.$on('logIn', (msg) => {
            console.log('触发了app-logIn');

            // 登录后判断是否弹出服务费提醒弹窗
            _this
                .$post('/service_fee/getServiceChargeRemind')
                .then((res) => {
                    if (res.data.is_true == 1) {
                        _this.total_money = res.data.total_money;
                        _this.serviceFee_isShow = !_this.serviceFee_isShow;
                    }
                })
                .catch((err) => {});
        });
    }
};
</script>



<style>
@import './assets/css/main.css';
@import './assets/css/color-dark.css';

.go-new {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%);
    padding: 10px;
    background-color: #ccc;
    border-radius: 10px;
}
.baidu {
    display: none !important;
}
</style>
